import { Fragment } from "react";
import { Button, Popover } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import { analytics } from "../../../services/firebase";
import "../style.css";
import "./../../../App.css";

import {
  CANAL_DENUNCIAS_ECONOMICAS,
  CANAL_DENUNCIAS_SEXUALES,
} from "../../../constants/urls";

export default function DenunciasAccesos(props) {
  const {
    anchorDenunciasAccesos,
    handleClickDenunciasAccesos,
    openPopoverDenunciasAccesos,
    handleCloseDenunciasAccesos,
    setAnchorDenunciasAccesos,
    idDenunciasAccesos,
    claimUser,
  } = props;

  return (
    <Fragment>
      <a
        onClick={handleClickDenunciasAccesos}
        style={{ color: "#731f1f", textDecoration: "none", cursor: "pointer" }}
      >
        <strong>Canal de Denuncias</strong>
      </a>
      <Popover
        id={idDenunciasAccesos}
        open={openPopoverDenunciasAccesos}
        anchorEl={anchorDenunciasAccesos}
        onClose={handleCloseDenunciasAccesos}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div style={{ margin: 10, width: 400 }}>
          <Button
            component="a"
            href={CANAL_DENUNCIAS_SEXUALES}
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent(
                "Home_link_superior_Reportar_canal_de_Denuncias",
                {
                  usuarioCorreo: claimUser.email,
                  usuarioNombre: claimUser.name,
                  usuarioContrato: claimUser.proyecto,
                }
              );
              setAnchorDenunciasAccesos(null);
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>Denuncias por Hostigamiento Sexual/Laboral</strong>
          </Button>
          <Button
            component="a"
            href={CANAL_DENUNCIAS_ECONOMICAS}
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent(
                "Home_link_superior_Reportar_canal_de_Denuncias",
                {
                  usuarioCorreo: claimUser.email,
                  usuarioNombre: claimUser.name,
                  usuarioContrato: claimUser.proyecto,
                }
              );
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>
              Denuncias Prevención Delitos Económicos y Otras Denuncias
            </strong>
          </Button>

          <Button
            component="a"
            href="https://docs.google.com/forms/d/e/1FAIpQLSf3znbHBlT2qWaAsJLNdnTolOVU2LfVWv8b46oQJOCvvE4sEg/viewform"
            target="_blank"
            style={{
              color: "#731f1f",
              textDecoration: "none",
              textTransform: "none",
              width: "100%",
              justifyContent: "space-between",
            }}
            onClick={() => {
              analytics.logEvent(
                "Home_link_superior_Reportar_canal_de_Denuncias",
                {
                  usuarioCorreo: claimUser.email,
                  usuarioNombre: claimUser.name,
                  usuarioContrato: claimUser.proyecto,
                }
              );
            }}
            endIcon={
              <OpenInNew
                style={{ color: "lightgray", verticalAlign: "middle" }}
              />
            }
          >
            <strong>
              Consultas
            </strong>
          </Button>
        </div>
      </Popover>
    </Fragment>
  );
}
